import {
  VuexModule,
  getModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import { NotifyHelper } from 'vue-kit'
import { Errors } from '@/dto/ErrorsResponse'
import Limit from '@/dto/limits/Limit'
import LimitsService from '@/services/LimitsService'

@DynamicModule
class LimitsStore extends VuexModule {
  public limits: Limit[] = []
  public limitId: number | null = null
  public errors: Errors = {}

  get limit(): Limit | null {
    return this.limits.find(limit => this.limitId === limit.id) || null
  }

  @Mutation
  public selectLimit(limitId: number | null) {
    this.limitId = limitId
  }

  @Mutation
  public addLimitToList(model: Limit) {
    this.limits.unshift(model)
  }

  @Mutation
  public removeLimitFromList(limitId: number) {
    this.limits.splice(
      this.limits.findIndex(limit => {
        return limit.id === limitId
      }),
      1
    )
  }

  @Mutation
  public updateLimitInList(model: Limit) {
    const index = this.limits.findIndex(limit => limit.id === model.id)
    this.limits.splice(index, 1, model)
  }

  @Mutation
  public setErrors(errors: Errors) {
    this.errors = errors
  }

  @Action({ rawError: true })
  async saveLimit(model: Limit): Promise<any> {
    return LimitsService.saveLimit(model)
      .then((limit: Limit) => {
        NotifyHelper.success('Лимит сохранен сохранен!')

        if (model.id) {
          this.updateLimitInList(limit)
        } else {
          this.addLimitToList(limit)
        }

        return limit
      })
      .catch(error => {
        if (!error.response.data.errors) {
          NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
        }

        this.setErrors(error.response.data.errors)
      })
  }

  @Action
  public removeLimit(limitId: number) {
    return LimitsService.deleteLimit(limitId)
      .then(() => {
        NotifyHelper.success('Лимит удален!')
        this.removeLimitFromList(limitId)
      })
      .catch(() => {
        NotifyHelper.error('Ошибка сервера.')
      })
  }

  @MutationAction({ mutate: ['limits'] })
  async loadLimits() {
    const limits = await LimitsService.loadLimits()

    return { limits }
  }
}

export default getModule(LimitsStore)
